import React from "react";
import { ICONS } from "../../../../assets/icons/index";
import Group from "../../../../assets/customSVG/Group";


const FileDownloadView = ({ response }) => {
  return (
    <div className="flex-column">
      {response?.map((response, index) => {
        const displayName = response.type === 'audience_set' 
          ? response.audience_set_name 
          : response.file_name;
          
        return (
          <React.Fragment key={response.id || index}>
            {displayName && (
              <div className="FileMains flex-row ml-4">
                <div className="File-container flex-row align-center">
                  <div className="File-wrapper flex-column">
                    <div className="flex-row align-center">
                      {response.type === 'audience_set' ? (
                        <Group width="30" height="30" fill="#05805c"/>
                      ) : (
                        <img 
                          src={ICONS?.AudienceFileIcon}
                          alt={response.type === 'audience_set' ? 'audience set icon' : 'file icon'} 
                        />
                      )}
                      <div className="flex-column">
                        <p>{displayName}</p>
                        <div className="flex-row align-center pt-0.5">
                          <div className="flex-row align-center">
                            <img
                              src={ICONS?.BroadcastProfileIcon}
                              alt="BroadcastRedInfoIcon"
                              style={{
                                width: "20px",
                              }}
                            />
                            <div
                              className="flex-row"
                              style={{ padding: "0px 5px" }}
                            >
                              <p
                                style={{
                                  color: "var(--textBlack)",
                                  fontWeight: "700",
                                  fontSize: "0.75vw",
                                }}
                              >
                                {response?.valid_count}
                              </p>
                              <span
                                className=" pr-4 flex-row align-center"
                                style={{ borderRight: "1px solid #D1D3D8" }}
                              >
                                Unique Contacts
                              </span>
                            </div>
                          </div>
                          <div className="flex-row align-center">
                            <img
                              src={ICONS?.BroadcastCopyIcon}
                              alt="BroadcastRedInfoIcon"
                              style={{
                                width: "20px",
                              }}
                            />
                            <div
                              className="flex-row"
                              style={{ padding: "0px 5px" }}
                            >
                              <p
                                style={{
                                  color: "var(--textBlack)",
                                  fontWeight: "700",
                                  fontSize: "0.75vw",
                                }}
                              >
                                {response?.duplicate_count || 0}
                              </p>
                              <span
                                className="pr-4"
                                style={{ borderRight: "1px solid #D1D3D8",paddingTop: '2px' }}
                              >
                                Duplicates
                              </span>
                            </div>
                          </div>
                          <div className="flex-row align-center">
                            <img
                              src={ICONS?.BroadcastRedInfoIcon}
                              alt="BroadcastRedInfoIcon"
                              style={{
                                width: "20px",
                              }}
                            />
                            <p
                              className="flex-row"
                              style={{
                                color: "var(--textBlack)",
                                fontWeight: "700",
                                fontSize: "0.75vw",
                                padding: "0px 10px",
                              }}
                            >
                              {response?.invalid_count || 0}
                            </p>
                            <span className="">Invalids</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default FileDownloadView;
